<template>
  <p :class="['field', { invalid: isInvalid }]">
    <label v-if="required" :for="id">
      <slot></slot>
      *
    </label>
    <label v-else :for="id">
      <slot></slot>
    </label>
    <vue-editor
        :id="id"
        :name="id"
        :custom-toolbar="customToolbar"
        v-model="htmlVal"
        :disabled="disabled"
        :editorToolbar="customToolbar"
        @focus="emitFocus"
        @blur="emitBlur(true)"
    ></vue-editor>
  </p>
</template>

<script>
import {VueEditor} from "vue2-editor"

export default {
  name: "HtmlEditor",
  components: {VueEditor},
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    customToolbar: {
      type: Array,
      default: () => ([
        [{ header: 1 }, { header: 2 }],
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
        ],
        ["link"],
        ["clean"]
      ])
    },
    body: String
  },
  data() {
    return {
      touched: false,
      forcedInvalid: false,
      tempValue: null,
    }
  },
  methods: {
    emitFocus() {
      this.$emit('focus', true)
    },
    setTouched(value) {
      this.touched = value
    },
    emitBlur(value) {
      this.setTouched(value)
      this.$emit('blur', value)
    },
    setForcedInvalid(value = false, invalidText = null) {
      this.forcedInvalid = value
      this.invalidText = value === false ? null : invalidText
    }
  },
  computed: {
    htmlVal: {
      get() {
        return this.body
      },
      set(val) {
        this.$emit('newVal', val)
        this.tempValue = val
      }
    },
    isInvalid() {
      return (this.touched && this.required && !this.tempValue) || this.isForcedInvalid
    },
    isForcedInvalid() {
      return this.forcedInvalid
    }
  },
 }
</script>



// WEBPACK FOOTER //
// src/components/common/HtmlEditor.vue